import Modal from '@/components/base/Modal';
import StatusBadge from '@/components/base/StatusBadge';
import type { Campaign } from '@/types/portal';

interface AddToCampaignModalProps {
  open: boolean;
  creatorName: string;
  campaigns: Campaign[];
  onClose: () => void;
  onSelect: (campaignId: string) => void;
}

/**
 * Lets a creator be attached to a campaign when Discovery is opened outside a
 * specific campaign context. Picking one adds the creator and returns to that
 * campaign's Creators tab.
 */
export default function AddToCampaignModal({
  open,
  creatorName,
  campaigns,
  onClose,
  onSelect,
}: AddToCampaignModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Add to campaign"
      subtitle={
        creatorName
          ? `Choose a campaign to add ${creatorName} to.`
          : 'Choose a campaign to add this creator to.'
      }
      icon="ri-user-add-line"
    >
      <div className="space-y-2">
        {campaigns.map((campaign) => (
          <button
            key={campaign.id}
            type="button"
            onClick={() => onSelect(campaign.id)}
            className="flex w-full items-center justify-between gap-3 rounded-md border border-background-200 bg-background-50 px-3 py-2.5 text-left transition-colors cursor-pointer hover:border-secondary-300 hover:bg-background-100"
          >
            <span className="min-w-0">
              <span className="block truncate text-sm font-medium text-foreground-950">
                {campaign.name}
              </span>
              <span className="block truncate text-xs text-foreground-500">
                {campaign.brandClient} · {campaign.markets.join(', ')}
              </span>
            </span>
            <StatusBadge status={campaign.status} />
          </button>
        ))}
      </div>
    </Modal>
  );
}